import { z } from 'zod';

/**
 * Build type enum schema
 */
export const BuildTypeSchema = z.enum(['apk', 'aab', 'web', 'zip', 'web_export']).describe('Type of build to create');
/**
 * Build job status enum schema
 * Re-uses the same values as the internal BuildJobStatus but for public API
 */
export const BuildJobStatusSchema = z
  .enum(['waiting', 'running', 'complete', 'error', 'cancelled'])
  .describe('Current status of a build job');

export function isValidBuildJobStatus(status: string): status is BuildJobStatus {
  return BuildJobStatusSchema.safeParse(status).success;
}
// Export TypeScript types
export type BuildType = z.infer<typeof BuildTypeSchema>;
export type BuildJobStatus = z.infer<typeof BuildJobStatusSchema>;
